// This icon file is generated automatically.
var PFastForwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.4 5.8L5.91 2.27a.25.25 0 00-.41.2v7.06c0 .2.25.33.41.2l4.5-3.53a.25.25 0 000-.4zm-5 0L.91 2.27a.25.25 0 00-.41.2v7.06c0 .2.25.33.41.2l4.5-3.53c.06-.05.09-.13.09-.2a.25.25 0 00-.1-.2zm6-3.92h-.8c-.05 0-.1.04-.1.09v8.06c0 .05.05.1.1.1h.8c.05 0 .1-.05.1-.1V1.97c0-.05-.05-.1-.1-.1z", "fill-rule": "nonzero" } }] }, "name": "p-fast-forward", "theme": "outlined" };
export default PFastForwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFastForwardOutlined.js
// module id = 3381
// module chunks = 0